<template slot="headers" slot-scope="props">
  <v-container fluid class="pa-2" style="width: 800px">
    <v-layout row>
      <v-flex sm4 md4></v-flex>
      <v-flex sm8 md8>
        <v-container class="py-2 pr-0" grid-list-xl fluid>
          <v-layout row align-center>
            <v-flex xs12 sm8 md9 class="py-0">
              <v-layout row align-center>
                <v-flex xs6 sm10 md11 class="px-0">
                  <p
                    class="text-xs-right grey--text caption"
                    style="font-size: 14px; margin-top: 14px;"
                  >Row per Page:</p>
                </v-flex>
                <v-flex xs6 sm2 md1 class="text-xs-center">
                  <v-layout row align-center>
                    <v-flex xs7 sm12>
                      <v-select
                        v-model="pageLimit"
                        :items="page"
                        @input="limitClick"
                        style="font-size: 14px;"
                        class="grey--text"
                        id="selected"
                        dense
                        height="20px"
                        :disabled="this.totalItems < 10 ? true : false"
                      ></v-select>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 sm4 md3 class="py-0">
              <v-layout row align-center>
                <v-flex xs6 sm6 class="px-0 pl-3">
                  <p
                    class="text-xs-center grey--text caption"
                    style="font-size: 14px; margin-top: 14px;"
                  >{{ itemFrom + " - " + itemTo + " of " }} {{ this.$store.state.fareMatrixItems.length }}</p>
                </v-flex>
                <v-flex xs6 sm6>
                  <v-layout row style="padding-right: 100px;">
                    <v-flex sm6 class="mr-3 pl-0">
                      <v-btn fab light small flat @click="backClick" :disabled="disabledBack">
                        <v-icon dark>chevron_left</v-icon>
                      </v-btn>
                    </v-flex>
                    <v-flex sm6>
                      <v-btn fab light small flat @click="nextClick" :disabled="disabledNext">
                        <v-icon dark>chevron_right</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-container fluid class="ma-0 pa-0">
        <v-data-table
          class="scrolling-wrapper"
          :headers="uploadHeaders"
          :items="uploadItems"
          hide-actions
          disable-initial-sort
        >
          <template slot="headers" slot-scope="props">
            <tr>
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="[
                    'column sortable', 
                    header.value === queryParams.order ? 'active' : '', 
                    'text-xs-'+header.align
                  ]"
              >
                <span>{{ header.text }}</span>
              </th>
            </tr>
          </template>
          <template slot="items" slot-scope="props">
            <td v-if="dialogType==='edit'" class="text-xs-center">
              <edit-button
                style="box-sizing: border-box; padding: 0px; margin: 0px"
                @edit="editItem(props.item)"
              ></edit-button>
              <v-tooltip top>
                <v-btn icon slot="activator" @click="location(props.item)">
                  <v-icon color="red">pin_drop</v-icon>
                </v-btn>
                <span>Edit</span>
              </v-tooltip>
            </td>
            <td class="text-xs-center">{{ props.index + queryParams.offset + 1 }}</td>
            <td class="text-xs-left text-uppercase">{{ props.item.name }}</td>
            <td class="text-xs-right">{{ props.item.post }}</td>
            <td class="text-xs-left text-uppercase">{{ props.item.province }}</td>
            <td class="text-xs-left">{{ props.item.is_stop }}</td>
            <td
              class="text-xs-right"
            >{{ $amountInPeso(props.item.regular_fare ? props.item.regular_fare : 0) }}</td>
            <td
              class="text-xs-right"
            >{{ $amountInPeso(props.item.discounted_fare ? props.item.discounted_fare : 0) }}</td>
            <td
              class="text-xs-right"
            >{{ $amountInPeso(props.item.special_fare ? props.item.special_fare : 0) }}</td>
            <td
              class="text-xs-right"
            >{{ $amountInPeso(props.item.special_discounted_fare ? props.item.special_discounted_fare : 0) }}</td>
            <td
              class="text-xs-right"
            >{{ $amountInPeso(props.item.special_fare_2 ? props.item.special_fare_2 : 0) }}</td>
            <td
              class="text-xs-right"
            >{{ $amountInPeso(props.item.special_discounted_fare_2 ? props.item.special_discounted_fare_2 : 0) }}</td>
            <td
              class="text-xs-right"
            >{{ $amountInPeso(props.item.special_fare_3 ? props.item.special_fare_3 : 0) }}</td>
            <td
              class="text-xs-right"
            >{{ $amountInPeso(props.item.special_discounted_fare_3 ? props.item.special_discounted_fare_3 : 0) }}</td>
            <td
              class="text-xs-right"
            >{{ $amountInPeso(props.item.special_fare_4 ? props.item.special_fare_4 : 0) }}</td>
            <td
              class="text-xs-right"
            >{{ $amountInPeso(props.item.special_discounted_fare_4 ? props.item.special_discounted_fare_4 : 0) }}</td>
            <td
              class="text-xs-right"
            >{{ $amountInPeso(props.item.special_fare_5 ? props.item.special_fare_5 : 0) }}</td>
            <td
              class="text-xs-right"
            >{{ $amountInPeso(props.item.special_discounted_fare_5 ? props.item.special_discounted_fare_5 : 0) }}</td>
          </template>
        </v-data-table>
      </v-container>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      pageLimitValue: 10,
      dataId: "",
      disabledBack: true,
      disabledNext: false,
      queryParams: {
        offset: 0,
        limit: 10,
        order: ""
      }
    };
  },
  props: {
    uploadHeaders: {
      type: Array
    },
    uploadItems: {
      type: Array
    },
    dialogType: {
      type: String
    },
    page: {
      type: Array
    }
  },
  computed: {
    pageLimit: {
      get() {
        return 10;
      },
      set(val) {
        this.queryParams.limit = val;
        this.queryParams.offset = 0;
        this.pageLimitValue = val;
      }
    },
    itemFrom() {
      return this.queryParams.offset + 1;
    },
    itemTo() {
      if (this.queryParams.limit >= this.$store.state.fareMatrixItems.length) {
        return this.$store.state.fareMatrixItems.length;
      } else {
        return this.queryParams.limit;
      }
    },
    totalItems() {
      return this.$store.state.fareMatrixItems.length;
    }
  },
  methods: {
    async limitClick(event) {
      this.queryParams.limit = this.pageLimitValue;
      this.$emit(
        "setQueryParamsLimit",
        this.queryParams.offset,
        this.queryParams.limit
      );
    },
    async backClick(event) {
      this.queryParams.offset -= this.pageLimitValue;
      this.queryParams.limit -= this.pageLimitValue;
      this.$emit(
        "backClickFM",
        this.queryParams.offset,
        this.queryParams.limit
      );
      if (this.queryParams.offset <= 0) {
        this.disabledBack = true;
      } else {
        this.disabledBack = false;
      }
      if (this.queryParams.limit < this.$store.state.fareMatrixItems.length) {
        this.disabledNext = false;
      }
    },
    async nextClick(event) {
      this.queryParams.offset += this.pageLimitValue;
      this.queryParams.limit += this.pageLimitValue;
      this.$emit(
        "nextClickFM",
        this.queryParams.offset,
        this.queryParams.limit
      );
      if (this.queryParams.offset > 0) {
        this.disabledBack = false;
      } else {
        this.disabledBack = true;
      }

      if (this.queryParams.limit >= this.$store.state.fareMatrixItems.length) {
        this.disabledNext = true;
      }
    },
    async editItem(item) {
      this.$emit("editClickFM", item);
    },
    async location(item) {
      this.$emit("location", item);
    }
  }
};
</script>

<style scoped>
.scrolling-wrapper {
  overflow-x: hidden;
  overflow-y: hidden;
  white-space: nowrap;
}
.table-controls {
  padding: 0 !important;
}
table.v-table td,
th {
  box-shadow: 1px 0px 0px 0px #eee;
}
table.v-table tbody tr {
  cursor: pointer !important;
}
.current-row {
  background-color: #ddd;
}
.row-active {
  box-shadow: 4px -1px 0px 0px rgb(76, 175, 80) inset;
}
.row-inactive {
  color: rgb(244, 67, 54);
  box-shadow: 4px 0px 0px 0px rgb(244, 67, 54) inset;
}
table.v-table td,
th {
  height: 30px !important;
  padding: 0px 5px 0px 5px !important;
}
table.v-table thead tr:not(.v-datatable__progress) {
  height: 30px;
}
table.v-table th {
  padding-left: 5px !important;
  padding-right: 5px !important;
}
</style>